import React from "react";

const SortOrderHeader = ({ displayName, sortField, payloadSort, setSortOrderParent }) => {
  const isActive = payloadSort?.sort_by === sortField;
  const currentOrder = isActive ? payloadSort?.sort_type : null;

  const handleClickSort = () => {
    let newOrder;
    if (!isActive) {
      newOrder = "asc";
    } else if (currentOrder === "asc") {
      newOrder = "desc";
    } else if (currentOrder === "desc") {
      newOrder = null;
    }

    setSortOrderParent?.(newOrder ? { sort_by: sortField, sort_type: newOrder } : null);
  };

  return (
    <div
      className="flex items-center gap-2 justify-content-between cursor-pointer select-none w-full"
      onClick={handleClickSort}
      title={`Klik untuk mengurutkan ${displayName}`}
    >
      <span className="font-semibold text-blue-600">{displayName}</span>
      {isActive && currentOrder && (
        <i className={`text-gray-500 text-xs pi ${currentOrder === "asc" ? "pi-arrow-up" : "pi-arrow-down"}`}></i>
      )}
    </div>
  );
};

export const ColumnCutBonus = (handleSortOrder, payloadSort) => {
  return [
    {
      headerName: "No",
      field: "no",
      width: 80,
      pinned: "left",
      sortable: false,
      filter: false,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Worker ID",
      field: "workerId",
      flex: 1,
      width: 225,
      minWidth: 100,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Worker ID",
        sortField: "worker_id",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Worker Name",
      field: "workerName",
      flex: 1,
      width: 225,
      minWidth: 100,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Worker Name",
        sortField: "worker_name",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Worker Type",
      field: "workerType",
      flex: 1,
      width: 225,
      minWidth: 100,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Worker Type",
        sortField: "worker_type",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Amount",
      field: "initialAmount",
      flex: 1,
      width: 225,
      minWidth: 100,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Amount",
        sortField: "initial_amount",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      valueFormatter: (p) => `Rp ${Number(p.value || 0).toLocaleString("id-ID")}`,
      cellStyle: { fontWeight: "bold" },
    },

    {
      headerName: "Total Attendance",
      field: "totalJobs",
      flex: 1,
      width: 225,
      minWidth: 100,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Total Attendance",
        sortField: "total_jobs",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Bonus",
      field: "bonus",
      flex: 1,
      width: 225,
      minWidth: 100,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Bonus",
        sortField: "bonus",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      valueFormatter: (p) => `Rp ${Number(p.value || 0).toLocaleString("id-ID")}`,
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Total",
      field: "finalAmount",
      flex: 1,
      width: 225,
      minWidth: 100,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Total",
        sortField: "final_amount",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      valueFormatter: (p) => `Rp ${Number(p.value || 0).toLocaleString("id-ID")}`,
      cellStyle: { fontWeight: "bold" },
    },
  ];
};
